module.exports = "https://assets.sidelineswap.com/web/_next/static/videos/14-e313e4b7c6b0519efe22ac24b7d6a460.webm";